import './App.css';
import Homepage from './components/Homepage';

function App() {
  return (
    <div className="App">
      <h1 id="title">Superhero Database</h1>
      <Homepage />
    </div>
  );
}

export default App;
